import classnames from 'classnames';
import React from 'react';

interface RangeSliderTrackProps {
  className?: string;
  disabled?: boolean;
  getTrackProps: () => any;
  source: {
    id: string;
    value: number;
    percent: number;
  };
  target: {
    id: string;
    value: number;
    percent: number;
  };
}

export const RangeSliderTrack: React.FC<RangeSliderTrackProps> = ({
  className,
  disabled = false,
  getTrackProps,
  source,
  target,
}) => (
  <div
    className={classnames('range-slider__track', { 'range-slider__track--disabled': disabled }, className)}
    style={{
      left: `${source.percent}%`,
      width: `${target.percent - source.percent}%`,
    }}
    {...getTrackProps()}
  />
);
